import { ref, computed, type Ref } from 'vue'
import { defineStore } from 'pinia'
import { RoleType, type RoleDTOV1 } from '@/common/types/roles'
import { fetchRoles } from '@/common/services/RolesService'

export const useRolesStore = defineStore('roles', () => {
  const roles: Ref<RoleDTOV1[]> = ref([])
  const getSupervisorActiveRolesSet = computed(
    () =>
      new Set<string>(
        roles.value.reduce<string[]>((acc, role) => {
          if (role.active && role.type === RoleType.SUP) {
            acc.push(role.code)
          }
          return acc
        }, []),
      ),
  )

  async function loadRoles() {
    try {
      roles.value = await fetchRoles()
    } catch (error) {
      console.error(error)
    }
  }

  return {
    loadRoles,
    roles,
    getSupervisorActiveRolesSet,
  }
})
